import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import ConfirmationPanel from './ConfirmationPanel';

interface ConfirmClosingConversationProps {
    confirm: () => void;
    cancel: () => void;
}

function ConfirmClosingConversation({
    confirm,
    cancel,
}: ConfirmClosingConversationProps): React.ReactElement<ConfirmClosingConversationProps> {
    const { t } = useTranslation(['conversationsFeature']);

    return (
        <ConfirmationPanel confirm={confirm} cancel={cancel}>
            <h3>{t('conversationsFeature:adminPanel.confirmation.closingConversation.header')}</h3>
            <Trans
                i18nKey="conversationsFeature:adminPanel.confirmation.closingConversation.body"
                components={{
                    p: <p />,
                    b: <b />,
                }}
            />
        </ConfirmationPanel>
    );
}

export default ConfirmClosingConversation;
